/* eslint-disable no-useless-escape */

export const WATCHDUTY_SCHEME = 'watchduty://';

export const TERMS_OF_SERVICE = 'https://www.watchduty.org/legal/eula';
export const PRIVACY_POLICY = 'https://www.watchduty.org/legal/privacy-policy';

export const AppStoreLinks = {
  iosBannerCampaign:
    'https://apps.apple.com/app/apple-store/id1574452924?pt=123122876&ct=App%20Banner%20in%20Mobile%20Browsers&mt=8',
  ios: 'https://apps.apple.com/us/app/watch-duty-wildfire/id1574452924',
  android: 'https://play.google.com/store/apps/details?id=org.watchduty.app',
} as const;

export const UsStatesAbbr = {
  Arizona: 'AZ',
  Alabama: 'AL',
  Alaska: 'AK',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
} as const;

export const DEFAULT_LAT = 0;

export const DEFAULT_LON = 0;

// Random limit - allows field to resize with content up to this limit
export const TEXTAREA_MAX_ROWS = 100;

export const EvacZoneStatuses = {
  orders: 'orders',
  warnings: 'warnings',
  advisories: 'advisories',
} as const;

export const EvacZoneStyles = {
  default: 'order_warning_advisory',
  readySetGo: 'ready_set_go',
  withLevels: 'ready_set_go_with_levels',
  reverseColors: 'ready_set_go_reverse_colors',
} as const;

export const LocationTypes = {
  evacShelter: 'evac_shelter',
  animalShelter: 'animal_shelter',
  info: 'info',
  general: 'general',
  food: 'food',
} as const;

export const LinkTypes = {
  phone: 'phone',
  website: 'website',
  email: 'email',
} as const;

export const GeoEventTypes = {
  wildfire: 'wildfire',
  location: 'location',
} as const;

// There are a few more but not currently supplied to the client
export type ExternalSource =
  | 'pulsepoint'
  | 'nifc'
  | 'wildcad'
  | 'chp'
  | 'aircraft_detection'
  | 'alert_west';

export const ExternalGeoNameMap: Record<ExternalSource, string> = {
  pulsepoint: 'Pulsepoint',
  wildcad: 'WildCAD',
  nifc: 'NIFC',
  chp: 'CHP',
  aircraft_detection: 'Aircraft Circling',
  alert_west: 'Camera hit',
};

// Taken from Yup's URL validation regex but modified to not require the protocol:
// https://github.com/jquense/yup/blob/089ce8bfa8137e0dd1886bd40301b96bcc6deef7/src/string.ts#L24
export const UrlRegex =
  /^(((https|ftp):)?\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

export const PhoneNumberRegex = /^(1|)?(\d{3})(\d{3})(\d{4})$/;

export const ABORT_SHARE_ERROR_STRING = 'Share canceled';

export const MAP_DOM_ELEMENT_ID = 'map-container';

export const SEARCH_DRAWER_WIDTH = 375;

const SEARCH_CARD_MIN_SNAP_PX = 70;

export const getSearchCardMinSnapPx = (): number => {
  const safeArea =
    getComputedStyle(document.documentElement).getPropertyValue(
      '--safeAreaInsetBottom',
    ) || '0px';

  // The bottom safe area on iOS
  const safeAreaPx = parseInt(safeArea.replace('px', ''), 10) / 3;

  return SEARCH_CARD_MIN_SNAP_PX + safeAreaPx;
};

export const EVAC_ZONE_STROKE_COLOR = '#000000';
export const ORDERS_COLOR = '#E25345';
export const WARNINGS_COLOR = '#FBC02D';
export const ADVISORIES_DEFAULT_COLOR = '#6393F2';
export const ADVISORIES_RSG_COLOR = '#509F4E';

export const EVAC_ZONE_LAYER_COLORS = {
  [EvacZoneStyles.default]: {
    orders: ORDERS_COLOR,
    warnings: WARNINGS_COLOR,
    advisories: ADVISORIES_DEFAULT_COLOR,
  },
  [EvacZoneStyles.readySetGo]: {
    orders: ORDERS_COLOR,
    warnings: WARNINGS_COLOR,
    advisories: ADVISORIES_RSG_COLOR,
  },
  [EvacZoneStyles.withLevels]: {
    orders: ORDERS_COLOR,
    warnings: WARNINGS_COLOR,
    advisories: ADVISORIES_RSG_COLOR,
  },
  [EvacZoneStyles.reverseColors]: {
    orders: ADVISORIES_RSG_COLOR,
    warnings: WARNINGS_COLOR,
    advisories: ORDERS_COLOR,
  },
} as const;

export const EVAC_ZONE_LABEL_TRANS_KEYS = {
  [EvacZoneStyles.default]: {
    orders: 'evacZones.default.orders',
    warnings: 'evacZones.default.warnings',
    advisories: 'evacZones.default.advisories',
  },
  [EvacZoneStyles.readySetGo]: {
    orders: 'evacZones.readySetGo.orders',
    warnings: 'evacZones.readySetGo.warnings',
    advisories: 'evacZones.readySetGo.advisories',
  },
  [EvacZoneStyles.withLevels]: {
    orders: 'evacZones.withLevels.orders',
    warnings: 'evacZones.withLevels.warnings',
    advisories: 'evacZones.withLevels.advisories',
  },
  [EvacZoneStyles.reverseColors]: {
    orders: 'evacZones.reverseColors.orders',
    warnings: 'evacZones.reverseColors.warnings',
    advisories: 'evacZones.reverseColors.advisories',
  },
} as const;

export const ORDERS_PATTERN = 'EvacOrderPattern';
export const ORDERS_REVERSE_PATTERN = 'EvacReverseOrderPattern';
export const WARNINGS_PATTERN = 'EvacWarningPattern';
export const ADVISORIES_DEFAULT_PATTERN = 'EvacAdvisoryBluePattern';
export const ADVISORIES_GREEN_PATTERN = 'EvacAdvisoryGreenPattern';
export const ADVISORIES_REVERSE_PATTERN = 'EvacReverseAdvisoryPattern';

export const MEMBERSHIP_PLANS = {
  yearly: 'yearly',
  proYearly: 'pro_yearly',
  proMonthly: 'pro_monthly',
} as const;

export const MEMBERSHIP_PLANS_AMOUNTS = {
  [MEMBERSHIP_PLANS.yearly]: 24.99,
  [MEMBERSHIP_PLANS.proYearly]: 99.99,
  [MEMBERSHIP_PLANS.proMonthly]: 29.99,
};

export const COORDINATE_DISPLAY_FRACTION_DIGITS = 6;

export type RouterEntityDrawer = 'wildfire' | 'location' | 'camera' | 'gauge';

export const ROUTER_ENTITY_TO_ROUTE_PATH_MAP: Record<
  RouterEntityDrawer,
  string
> = {
  wildfire: '/i/:geoEventId',
  location: '/location/:locationId',
  camera: '/camera/:cameraId',
  gauge: '/gauge/:gaugeId',
};

export const VIEW_REPORT_ROUTE_PATH = '/i/:geoEventId/reports/:id';
export const EDIT_REPORT_ROUTE_PATH =
  '/incident/:geoEventId/reports/:reportId/edit';
